import React, { useCallback } from 'react';

// DEPENDENCIES
import { compose } from 'redux';
import { useFormikContext } from 'formik';

// HELPERS
import { withRouter } from 'helpers/withRouter';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { documentChunkFetch, viewFile } from 'functions.js';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';
import Card from 'parts/card/Card';
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import InputAppendCol from 'routers/interface/sections/parts/InputAppendCol';

// STYLES
import styles from './rebate.module.scss';

// RENDER
const RenderRebateForm = compose(withRouter)(() => {
  const { values } = useFormikContext() || {};
  const { aryRebate } = values || {};

  const handleDownload = useCallback((fileId, fileName) => {
    // TODO: mimetype always 'application/pdf'?
    documentChunkFetch({
      endpoint: `${ENDPOINTS.uploads.sales.viewRebate}/${fileId}`,
      accept: 'pdf',
      contentType: 'pdf',
      mimeType: 'application/pdf',
      loadingMessage: 'Opening file',
      errorMessage: 'Unable to download attachment.',
      onSuccess: r => viewFile({ ...r, fileName}),
    });
  }, []);

  return (
    <Form.Body>
      {Array.isArray(aryRebate)
        ? aryRebate.map((v, i) => (
            <Form.PlainText
              key={`${v.sales_rebate_id}-${i}`}
              label={`Rebate ${i + 1}`}
              schema="dollars"
              value={v.item_Amount}
              input={{
                append: (
                  <InputAppendCol>
                    {v.item_name} {v.item_code ? `(${v.item_code})` : ''}
                  </InputAppendCol>
                )
              }}
              text={
                v.aryRebateAttachment?.length
                  ? v.aryRebateAttachment.map(a => (
                      <div key={a.rebateattachment_id} className="w-100 mb-2">
                        <Button.Link
                          icon="document"
                          className={styles.button}
                          onClick={() => handleDownload(a.rebateattachment_id, a.rebateattachment_filename)}
                        >
                          {a.rebateattachment_filename}
                        </Button.Link>
                      </div>
                    ))
                  : null
              }
            />
          ))
        : null}
    </Form.Body>
  );
});

export default function RebateInfo(props) {
  const { values } = useFormikContext() || {};
  return values && values.aryRebate && values.aryRebate?.length > 0 ? (
    <Card title="Rebates" body={<RenderRebateForm {...props} />} />
  ) : (
    <></>
  );
}
